/// <reference path="../lib/app.d.ts" />

import {Application} from "./application/application";

declare let cookie : any;
declare let debug : any;

window["SxcChatApplication"] = Application;

export default Application

// class SxcChatClient
// {
// 	private app : Application;
//
// 	constructor()
// 	{
// 		// app = new Sxc.Chat.Application();
// 	}
//
// 	/**
// 	 * Initializes the chat application.
// 	 * Heavy lifting only happens here
// 	 */
// 	init()
// 	{
//
// 	}
//
// 	/**
// 	 * Show the chat application with the specified room.
// 	 * Please make sure that the room is known by the chat server
// 	 * or hint it before you show it.
// 	 *
// 	 * @param roomID
// 	 */
// 	show(roomID : string)
// 	{
//
// 	}
//
// 	/**
// 	 * Resets the chat app and hides it.
// 	 */
// 	hide()
// 	{
//
// 	}
//
// 	/**
// 	 * Provides data for a specific room to make sure the app has the most basic info
// 	 * it needs even if the server doesn't know about the room
// 	 *
// 	 * Should be used before joining a possibly offline room
// 	 */
// 	hintRoom(roomID: string,
// 	         screenName : string,
// 	         profilePic : string)
// 	{
//
// 	}
// }
